import { render, staticRenderFns } from "./not-found-page.vue?vue&type=template&id=06bf4fe2&scoped=true"
import script from "./not-found-page.ts?vue&type=script&lang=ts&external"
export * from "./not-found-page.ts?vue&type=script&lang=ts&external"
import style0 from "./not-found-page.less?vue&type=style&index=0&id=06bf4fe2&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf4fe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06bf4fe2')) {
      api.createRecord('06bf4fe2', component.options)
    } else {
      api.reload('06bf4fe2', component.options)
    }
    module.hot.accept("./not-found-page.vue?vue&type=template&id=06bf4fe2&scoped=true", function () {
      api.rerender('06bf4fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/not-found-page/not-found-page.vue"
export default component.exports